/* eslint-disable */
export default {
    form_project_name_placeholder: "Tragen Sie hier den Projektnamen ein",
    form_value_can_not_be_empty: "Dieser Wert darf nicht leer sein",
    form_could_not_process_your_request: "Kann Ihre Anfrage nicht verarbeiten",
    form_input_type_could_not_be_determined: "Es kann kein Eingabetyp bestimmt werden für Typ:",
    form_could_not_find_form_field: "Es kann kein Formularfeld gefunden werden mit ID:",
    form_submit: "Versenden",
    form_loading_form: "Formular wird geladen",
    form_close: "Schließen",
    form_organisation_name: "Organisationsname",
    form_job_function_name: "Funktionsbezeichnung",
    form_job_function_name_placeholder: "Geben Sie hier die Funktionsbezeichnung ein",
    form_organisation_name_placeholder: "Geben Sie hier den Namen der Organisation ein",
    form_project_name: "Projektname",
    form_project_product: "Produkt",
    form_option_product_selection: "Auswahl",
    form_option_product_development: "Entwickeln",
    form_option_product_selection_development: "Auswählend entwickeln",
    form_option_nederlands: "Niederländisch",
    form_option_engels: "Englisch",
    form_account_first_name: "Vorname",
    form_account_infix: "Namenszusatz",
    form_account_last_name: "Nachname",
    form_account_gender: "Geschlecht",
    form_account_has_role_email: "E-Mail-Adresse",
    form_account_has_role_language: "Sprache",
    form_education_level: "Was ist das erforderliche Bildungsniveau?",
    form_participant_session_appointment_date: "Termin",
    form_comments: "Anmerkungen",
    form_consultant: "Berater",
    form_option_male: "Mann",
    form_option_female: "Frau",
    form_option_other: "Anders",
    form_participant_first_name_placeholder: "Tragen Sie den Vornamen des/der Teilnehmers/Teilnehmerin ein",
    form_participant_infix_placeholder: "Tragen Sie den Namenszusatz des/der Teilnehmers/Teilnehmerin ein",
    form_participant_last_name_placeholder: "Tragen Sie den Nachnamen des/der Teilnehmers/Teilnehmerin ein",
    form_participant_email_placeholder: "Tragen Sie die E-Mail-Adresse des/der Teilnehmers/Teilnehmerin ein",
    form_option_choose_language: "Wählen Sie eine Sprache für den/die Teilnehmer/in",
    form_participant_session_appointment_date_placeholder: "Selektieren Sie ein Datum",
    form_comments_placeholder: "Geben Sie Ihre Anmerkungen ein",
    form_option_low: "FOS",
    form_option_middle: "FH",
    form_option_high: "Akademisch",
    form_email: "E-Mail-Adresse",
    form_account_email_placeholder: "Geben Sie die E-Mail-Adresse des/der Nutzers/in ein",
    form_account_role_label: "Funktion",
    form_display_name: "Anzeigename",
    form_account_display_name_placeholder: "Geben Sie einen Anzeigenamen für den Nutzer ein",
    form_infix: "Namenszusatz",
    form_account_infix_placeholder: "Geben Sie den Namenszusatz des/der Nutzers/in ein",
    form_account_last_name_placeholder: "Geben Sie den Nachnamen des/der Nutzers/in ein",
    form_last_name: "Nachname",
    form_first_name: "Vorname",
    form_account_first_name_placeholder: "Geben Sie den Vornamen des/der Nutzers/in ein",
    form_option_role_application_managers: "Anwendungsmanager",
    form_option_role_consultants: "Berater",
    form_option_role_bedrijfsbureau: "Planning & Support",
    form_option_role_backoffice: "Backoffice",
    form_option_role_client_center: "Kundencenter",
    form_option_role_assessment_team: "Assessment-Team",
    form_option_role_assessors: "Assessor",
    form_gender: "Geschlecht",
    form_option_choose_gender: "Wählen Sie ein Geschlecht",
    form_stars_required: "* Pflichtfelder",
    form_option_choose_education_level: "Wählen Sie ein Bildungsniveau",
    form_option_choose_consultant: "Keinen Berater ausgewählt",
    form_option_choose_product: "Wählen Sie ein Produkt",
    form_option_choose_user_role: "Wählen Sie eine Funktion",
    form_error_not_blank: "Das Feld darf nicht leer sein",
    form_error_length_maximum: "Der Wert in diesem Feld ist zu lang",
    form_error_length_minimum: "Der Wert in diesem Feld ist zu kurz",
    form_error_duplicate_entry: "Diese Wert besteht bereits",
    form_error_password_contains_spaces: "Das Passwort darf keine Leerzeichen enthalten",
    form_error_password_do_not_match: "Die Passwörter stimmen nicht überein",
    form_error_password_too_short: "Das Passwort muss mindestens 8 Zeichen enthalten",
    form_error_password_too_long: "Das Passwort ist zu lang",
    form_error_invalid_email: "Die E-Mail-Adresse ist ungültig",
    form_error_duplicate_non_participant_role: "Dieser Nutzer wurde zuvor mit der ausgewählten Rolle eingeladen",
    form_error_invalid_field_value: "Der Wert in diesem Feld ist ungültig",
    form_error_email_duplicate_in_project: "Dieser Teilnehmer besteht bereits",
    form_error_duplicate_custom_competency: "Diese Kompetenz besteht bereits",
    form_error_registration_user_already_exists: "Dieser Nutzer besteht bereits. Klicken Sie auf Anmelden oder Passwort vergessen, um fortzufahren.",
    form_cancel: "Annullieren",
    form_highest_basic_education_level: "Welches ist Ihr höchstes Bildungsniveau im Sekundarbereich?",
    form_highest_advanced_education_level: "Welches ist Ihr höchstes Bildungsniveau in der Hochschul- oder Berufsausbildung?",
    form_highest_basic_education_level_placeholder: "Wählen Sie ein Bildungsniveau",
    form_highest_advanced_education_level_placeholder: "Wählen Sie ein Bildungsniveau",
    form_appendixes_to_hide_online: "Verborgene Anlagen",
    form_account_date_of_birth: "Geburtsdatum",
    form_appendixes_to_hide_pdf: "Verborgene Anlagen",
    form_option_persona_fit: "Persona.fit",
    form_option_working_styles: "Arbeitsstile",
    form_option_influencing_styles: "Beeinflussungsstile",
    form_option_motives: "Triebfedern",
    form_option_personality: "Persönlichkeit",
    form_option_intellectual_capabilities: "Intellektuelle Fähigkeiten",
    form_error_participant_session_invite_failed: "Das Versenden der E-Mail ist misslungen",
    form_form_fields_not_loaded: "Formularfelder bestehen nicht! API-Anruf ist wahrscheinlich misslungen ",
    update_participant_detail_save: "Speichern",
    update_participant_detail_page_heading: "Persönliches Profil",
    update_participant_detail_form_heading: "Persönliche Angaben",
    update_participant_detail_form_heading_label: "Nachfolgende Angaben sind bei uns bekannt",
    form_date_of_birth: "Geburtsdatum",
    form_report_receivers_placeholder: "Berichtempfänger",
    form_report_receivers: "Berichtempfänger",
    form_sub_organisation_name_placeholder: "Geben Sie hier den Namen der Unterorganisation ein",
    form_sub_organisation_name: "Name der Unterorganisation",
    form_report_receiver_account_gender: "Geschlecht",
    form_report_receiver_account_has_role_email: "E-Mail-Adresse",
    form_report_receiver_account_last_name: "Nachname",
    form_report_receiver_account_infix: "Namenszusatz",
    form_report_receiver_account_first_name: "Vorname",
    form_error_report_receiver_already_exists: "Dieser Berichtempfänger besteht bereits, wählen Sie ihn in der Liste aus",
    form_option_role_office_manager: "Office Manager",
    form_choose_organisations_title: "Organisationen",
    form_choose_project_title: "Projekt",
    form_product_selection: "Auswahl",
    form_product_selection_development: "Auswählend entwickeln",
    form_product_development: "Entwickeln",
    form_many_participant_session_to_one_product: "Produkt",
    form_low: "FOS",
    form_high: "Akademischer Abschluss (Stufe 7)",
    form_middle: "FH",
    form_male: "Mann",
    form_other: "Anders",
    form_female: "Frau",
    form_one_participant_session_to_many_active_competency: "Kompetenzen hinzufügen",
    "form_nl-_n_l": "Niederländisch",
    "form_en-_g_b": "Englisch",
    form_product_building_docks: "Building Docks",
    form_product_talent_fit: "Talent Fit",
    form_product: "Produkt",
    form_error_not_email: "Die eingegebene E-Mail-Adresse ist ungültig",
    form_product_wpq: "WPQ",
    form_product_personafit2: "Persona.fit 2",
    form_product_wpq_description: "...",
    form_product_persona_fit2_description: "...",
    form_product_building_docks_description: "Vermittelt einen Einblick, wie ein Teilnehmer mit moralischen Dilemmata umgeht.",
    form_product_talent_fit_description: "Schnelle und objektive Ermittlung der Übereinstimmung zwischen Talent und Arbeitsumfeld (FH/akademische-Funktionen). Mit Entwicklungstipps für die Teilnehmer und Interviewfragen für die Interviewer.",
    form_product_selection_description: "Gibt einen Einblick in die Übereinstimmung zwischen dem Profil eines Teilnehmers und einer bestimmten Funktion.",
    form_product_selection_development_description: "Gibt einen Einblick in die Übereinstimmung zwischen dem Profil eines Teilnehmers und einer bestimmten Funktion. Plus Entwicklungstipps.",
    form_product_development_description: "Gibt einen Einblick in die Qualitäten, Entwicklungspunkte und Entwicklungsfähigkeit eines/einer Teilnehmer/in.",
    form_error_selected_product_is_invalid_for_parent_organisation: "Das ausgewählte Produkt ist für diese Organisation ungültig",
    form_input_value_too_short: "Der angegebene Wert muss mindestens 2 und maximal 255 Zeichen enthalten.",
    form_input_value_too_long: "Der angegebene Wert muss mindestens 2 und maximal 255 Zeichen enthalten.",
    form_input_value_required: "Dieses Feld ist obligatorisch.",
    form_choose_product_title: "Produkt",
    form_choose_completed_start_title: "Beginndatum",
    form_choose_completed_end_title: "Enddatum",
    form_product_persona_fit_2: "Persona.fit",
    form_option_role_finance: "Finanzverwaltung",
    form_enable_ability_tests: "Kapazitätstest(s) durchführen",
    form_ps_report_receivers: "Berichtempfänger",
    form_product_talent_navigator_description: "Schneller und objektiver Entwicklungsbericht mit Einblick in Stärken und Entwicklungspunkte. Zum Start, um die Entwicklung eines Mitarbeiters zu betrachten.",
    form_product_talent_navigator: "Talent Navigator",
    form_product_add_on_integrity: "Integrität",
    form_product_add_on_integrity_description: "Dieser Fokus gibt Aufschluss darüber, inwieweit der/die Teilnehmer/in integer handelt. Der Bericht gibt an, ob der/die Teilnehmer/in angesichts seines/ihres Profils und seiner/ihrer Einstellung eher im individuellen oder im kollektiven Interesse handelt.",
    form_is_demo_participant: "Ist dies ein Demo-Teilnehmer?",
    form_product_add_on: "Fokus (fakultativ)",
    form_option_role_client_admin: "Kundenverwaltung",
    form_product_pre_fit_description: "Schnell die besten Kandidaten für den nächsten Schritt im Auswahlverfahren erkennen.",
    form_product_pre_fit: "Pre Fit",
    form_cost_heading: "Kostenstelle (optional)",
    form_choose_cap_test_domain: "Die unten aufgeführten Spezialgebiete sind im Programm enthalten.",
    form_choose_cap_test_domain_helper_text: "Wählen Sie mindestens zwei optionale Bereiche, um die Zuverlässigkeit zu erhöhen. Wenn Sie keinen optionalen Bereich auswählen, wird der allgemeine G-Test verwendet und Sie sehen die Punktzahl für die allgemeinen intellektuellen Fähigkeiten im Bericht. Achtung: diese Auswahl hat Einfluss auf die Testzeit.",
    "form_de-_d_e": "Deutsch",
    "form_fr-_f_r": "Französisch",
    form_product_talent_scan_description: "Ein Online-Auswahltool, das Ihnen hilft, die talentiertesten Mitarbeiter für FOS-Positionen auszuwählen.",
    form_product_talent_scan: "Talent-Scan",
    form_product_add_on_work_safely: "Work safely",
    form_product_add_on_dealing_with_resistance: "Dealing with resistance",
    form_product_add_on_derailment: "Umgang mit Druck",
    form_password_show: "Show",
    form_password_hide: "Hide",
    form_saved_changes: "Changes are saved",
    form_unsaved_changes: "Changes are unsaved",
    form_save_button: "Save",
    form_product_multi_phase: "2-Phase Talent Fit",
    form_product_multi_phase_description: "A two-phased online selection tool that helps select the best participants from a large pool of applicants.",
    form_choose_roles_subtitle: "Below you will find the different roles within Neon. Choose one or more roles.",
    form_choose_roles_title: "Which role(s) do you want to add?",
    form_choose_reports_title: "Which reports can the user see?",
    form_choose_reports_subtitle: "Choose one of the options below.",
    form_option_role_office_manager_no_report: "Koordinator",
    form_choose_organisations_subtitle: "Choose the organization that the user has access to.",
    form_choose_organisations_title_descriptive: "Which organization do you want to add the user to?",
    form_choose_organisations_placeholder: "Choose organisation",
    form_option_role_report_receiver: "Berichtempfänger",
    form_all_reports_title: "All reports",
    form_all_reports_description: "With this role the user can see the reports of all participants of this organization.",
    form_no_reports_title: "No reports",
    form_no_reports_description: "The user can add participants but will not see any reports.",
    form_amend_roles_title: "Role(s)",
    form_product_add_on_critical_thinking: "Critical thinking",
    form_product_add_on_critical_thinking_description: "This add-on provides insight into the extent to which the participant is able to separate fact from assumptions and subsequently draw the correct conclusions.",
    form_product_add_on_derailment_description: "Dieses Add-on gibt Aufschluss darüber, welches toxische Verhalten unter Druck auftreten kann.",
    form_product_add_on_work_safely_description: "This add-on provides the insight in the factors that influence the risk-taking in the field of working safely.",
    form_product_add_on_dealing_with_resistance_description: "The way in which the employee deals with resistance determines work performance. This add-on provides insight into the risks.",
    form_product_add_on_no_extra_time: "No extra time",
    form_product_add_on_integrity_extra_time: "±45 minutes",
    form_product_add_on_critical_thinking_extra_time: "±30 Minuten",
    form_product_team_and_organisation: "Team & Organisation",
    form_product_team_and_organisation_description: "This product fosters transparent communication and provides intuitive collaboration tools, enabling teams and organizations to better understand each other's perspectives and foster cohesion.",
    form_product_add_on_dilemma_test: "Dilemma test",
    form_product_add_on_dilemma_test_description: "An ethical dilemma test evaluates the decision-making process in complex situations to assess ethical reasoning. It tests the ability to analyze scenarios and make informed judgments based on moral principles.",
    form_product_add_on_dilemma_test_extra_time: "±30 Minuten",
    form_download: "Herunterladen",
    form_assessment_form_description: "How would you like your assessment to take place? You can choose two options: online only and including the interpretation by a psychologist.",
    form_assessment_form_title: "Design your assessment",
    form_assessment_form_with_interpretation_title: "Online, with live interpretation and interview",
    form_assessment_form_without_interpretation_title: "Online assessment",
    form_assessment_form_with_interpretation_description: "This option is chosen when you want to add the interpretation by an LTP psychologist additionally. This makes decision-making even easier",
    form_assessment_form_without_interpretation_description: "The standard is an automated report after completion of the questionnaires. There is no interpretation from an LTP psychologist.",
    form_assessment_form_without_interpretation_time_indication: "No extra time",
    form_assessment_form_with_interpretation_time_indication: "+ 3 - 8 hours on LTP location",
    form_points_of_attention: "Gibt es Points of Interest, zusätzliche Informationen zum Profil oder Teilnehmer?",
    form_points_of_attention_placeholder: "Schreiben Sie einige zusätzliche Informationen, damit wir dies berücksichtigen können",
    form_project_prompt_name_placeholder: "Add the job title as used in AI prompts here",
    form_project_prompt_description_placeholder: "Add information about this job function that will be used in AI prompts",
    form_assessment_interpretation_title: "Interpretation",
    form_assessment_interpretation_description: "By selecting this is option, you can add interpretation by a psychologist to your online assessment.",
    form_assessment_interpretation_enabled: "Enabled",
    form_assessment_interpretation_disabled: "Disabled",
    form_product_test_ned: "",
    form_product_test_ned_description: "",
    form_product_test_ned_periodic: "",
    form_product_test_ned_periodic_description: "",
    form_interpretation_basic: "Interpretation Silver",
    form_interpretation_compact: "Interpretation Compact",
    form_interpretation_regular: "Interpretation Gold",
    form_interpretation_premium: "Interpretation Premium",
    form_file_uploader_button: "",
    form_profile_files_title: "2. An das Profil angehängte Dateien",
    form_error_password_not_valid: "Das Passwort sollte mindestens 12 Zeichen lang sein und einen Groß- und Kleinbuchstaben, ein Sonderzeichen und eine Ziffer enthalten.",
    form_assessment_goal_description: "Choose from mapping development potential, a selection issue or a combination of both.",
    form_assessment_goal_title: "Choose your goal",
    form_assessment_form_development_description: "Gewinnen Sie Einblick in das Entwicklungspotenzial",
    form_assessment_form_selection_development_description: "Finden Sie die besten Kandidaten für eine Position unter Berücksichtigung des Entwicklungspotenzials",
    form_assessment_form_selection_description: "Finden Sie die am besten geeigneten Kandidaten für eine Stelle",
    form_assessment_form_development_title: "Development",
    form_assessment_form_selection_development_title: "Selection Development",
    form_assessment_form_selection_title: "Selection",
    form_unspecified: "Das würde ich lieber nicht sagen",
    form_option_unspecified: "Das würde ich lieber nicht sagen",
    form_raf_product_selection: "",
    form_raf_product_selection_development: "",
    form_raf_product_development: "",
    form_interpretation_periodicAssessmentTestNed: "TestNed Scan Periodic",
    form_language: "Preferred language",
    form_profile_cv_title: "1. Lebenslauf: Der Teilnehmer wird aufgefordert, seinen Lebenslauf hochzuladen",
    form_plan_in_neon_toggle_label: "Speichern Sie AFAS-bezogene Termindetails direkt in NEON",
    form_participant_files_title: "3. Teilnehmerbezogene Dateien hinzufügen",
    form_product_no_online_scan: "",
    form_product_no_online_scan_description: "",
    form_file_item_upload_fail: "",
    form_file_item_upload_success: "",
    form_project_files_uploader_drag_and_drop: "Drag & Drop von Projektdateien",
    form_files_uploader_remove_file_modal_description: "",
    form_files_uploader_remove_file_modal_delete_button: "",
    form_files_uploader_remove_file_modal_title: "",
    form_files_uploader_error_upload: "",
    form_files_uploader_error_delete: "",
    form_files_uploader_error_open: "",
    form_is_pre_assessment_call_necessary: "Ist ein Vorabgespräch mit der Führungskraft notwendig?",
    form_manager_name_placeholder: "Name des Managers",
    form_manager_phone_placeholder: "Telefonnummer des Managers",
    form_manager_name_label: "",
    form_manager_phone_label: "",
    form_report_receivers_add: "",
    form_report_receivers_empty_state_header: "",
    form_report_receivers_empty_state_paragraph_1: "",
    form_report_receivers_empty_state_paragraph_2: "",
    form_update_button_label: "",
    form_report_receivers_remove_tooltip: "",
    form_cv_uploader_drag_and_drop: "Drag & Drop der CV-Datei",
    form_file_uploader_paragraph: "oder klicken Sie zum Durchsuchen",
    form_file_uploaded_success: "Die Datei wurde erfolgreich hochgeladen",
    form_education_level_description: "The requested level is needed to give you the right assessment for your question. In addition, it is also used for the capacity tests if these are included in the program.",
    form_education_level_title: "What is the required level for this profile?",
    form_education_level_low_description: "This profile is an \"executive\" profile in which the participant primarily works in execution.",
    form_education_level_middle_description: "This profile is a \"professional\" profile in which the participant focuses not only on execution but also on policy.",
    form_education_level_high_description: "This profile is a \"professional or executive\" profile in which the participant has a policy focus or is suited for higher executive positions.",
    form_education_level_high_title: "Master's degree",
    form_education_level_middle_title: "Higher vocational program",
    form_education_level_low_title: "Middle manual vocational program",
    form_product_executive_scan: "Executive Scan",
    form_product_executive_scan_description: "A scan for executive positions aimed at measuring leadership qualities, strategic insight, and personal effectiveness, with critical reasoning as a standard component of the program.",
    form_error_email_contains_space: "Die E-Mail-Adresse darf keine Leerzeichen enthalten",
    form_interpretation_executive: "Compact Executive Assessment",
    form_interpretation_cLevel: "Executive Assessment",
    form_internal_participant_toggle_checked: "",
    form_internal_participant_toggle_unchecked: "",
    form_pre_assessment_call_toggle_unchecked: "",
    form_points_of_attention_short: "Wichtige Punkte",
    form_participant_phone_label: "Participant's phone number",
    form_participant_employee_number: "Mitarbeiternummer",
    form_invited_email_address: "Invited e-mail address",
    form_registered_email_address: "Registered e-mail address",
    form_warning_email_addresses_different: "The invited and registered e-mail addresses are not the same",
    form_files_uploader_error_file_size: "",
    form_career_position_starter_title: "",
    form_career_position_professional_title: "",
    form_career_position_manager_title: "",
    form_career_position_executive_title: "",
    form_option_role_team_manager: "Team Manager",
    form_option_role_team_admin: "Team Admin",
    form_simple_raf_your_choices: "",
    form_career_position_description: "Je nach Niveau stellen wir das passende Programm zusammen und wählen einen geeigneten Betreuer aus.",
    form_career_position_title: "Welches Niveau hat die Stelle?",
    form_career_position_professional_description: "",
    form_career_position_manager_description: "",
    form_career_position_executive_description: "",
    form_assessment_goal_simple_raf_title: "Was bedeutet die Beurteilung?",
    form_assessment_goal_simple_raf_description: "Onze assessments geven altijd inzicht in het potentieel van de deelnemers. We kunnen dit (zonder meerprijs) uitbreiden met een selectie-advies.",
    form_assessment_form_simple_raf_development_title: "Entwicklung",
    form_assessment_form_simple_raf_selection_development_title: "Entwicklung mit Auswahlentscheidung",
    form_education_level_simple_raf_title: "Was ist das erforderliche Bildungsniveau?",
    form_education_level_simple_raf_description: "Darauf aufbauend legen wir das Niveau der Beurteilung und der Eignungstests fest.",
    form_assessment_form_simple_raf_title: "Was erwarten Sie vom Ergebnis der Beurteilung?",
    form_assessment_form_simple_raf_description: "Unsere Berater erstellen eine Bewertung auf Grundlage wissenschaftlicher Instrumente, die der Teilnehmer selbst ausfüllt, eines ausführlichen persönlichen Interviews, optional einer oder mehrerer praktischer Aufgaben und eines schriftlichen Berichts. Sie können sich auch dafür entscheiden, nur Einblicke in den Teilnehmer anhand wissenschaftlicher Instrumente zu erhalten.",
    form_assessment_form_simple_raf_without_interpretation_title: "Einblick (nur online)",
    form_assessment_form_simple_raf_with_interpretation_title: "Einblicke und Ratschläge"
};
